import {
  AppBar,
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography
} from '@mui/material';
import loaderImg from '../common/loader.gif';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectEndorsmentFormData,
  selectPolicyDetails,
  updateEndorsementScreenNumber,
  updateSelectedPolicyDetails
} from 'src/features/rfqDataSlice';
import CloseIcon from '@mui/icons-material/Close';
import SumInsuredPreview from './sections/SumInsuredPreview';
import DynamicFormView from './sections/DynamicForms/DynamicFormView';
import CustomerDetailsView from './sections/CustomerDetails/CustomerDetailsView';
import PremiumRequestPreview from './PremiumRequestPreview';
import request from 'src/utils/request';
import { LoadingButton } from '@mui/lab';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function EndorsementPreview({
  closeModal,
  setShowSnackBarAlert,
  preview,
  setPreview,
  anchorEl,
  setAnchorEl,
  open,
  setEndorsementData,
  endorsementData,
  getEndorsementData
}) {
  const policyDetailsData = useSelector(selectPolicyDetails);
  const endorsementFormData = useSelector(selectEndorsmentFormData);
  const dispatch = useDispatch();
  const goBack = () => {
    dispatch(updateEndorsementScreenNumber(2))
  }
  const [loader, setLoader] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [endorsementCreateStatus, setEndorsementCreateStatus] = useState<boolean>(false);
  const [previewHtml, setPreviewHtml] = useState<string | null>(null);
  const [previewLoading, setPreviewLoading] = useState<boolean>(false);


  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    getEndorsementPreview();
    if (endorsementFormData?.type == 'Extension-Endorsement' || endorsementFormData?.type == 'Cancellation-Endorsement') {
      getPolicyDetailData();
    }

  }, [])


  const handleRequest = (type) => {
    setAnchorEl(null);
    setPreview({
      status: true,
      type,
      insuranceCompanyId: policyDetailsData?.insuranceCompany?.id,
      branchId: policyDetailsData.branch.id,
      insuranceCompanyBranchId: policyDetailsData.insuranceCompanyBranch.id,
      insuranceCompanyBranchContact: null,
      otherContact: null,
      ids: endorsementData?.id ? [endorsementData.id] : [],
      endorsementType: endorsementFormData.type,
      premiumStatus: endorsementData.premiumStatus
    });
  };

  const sharePreview = (
    type,
    insuranceCompanyBranchContact,
    customMail,
    premium,
    premiumType,
    paymentMode,
    bankAccountId,
    gstPercentage
  ) => {


    setLoader(true);
    if (type === 'PremiumRequsetToCustomer') {


      request({
        url: 'endorsement/shareToCustomer',
        method: 'POST',
        data: {
          type: type,
          insuranceCompanyId: policyDetailsData.insuranceCompany.id,
          insuranceCompanyBranchId: policyDetailsData.insuranceCompanyBranch.id,
          // insuranceCompanyBranchContact: insuranceCompanyBranchContact,
          otherContact: customMail,
          ids: endorsementData?.id ? [endorsementData.id] : [],
          paymentType:
            paymentMode === 'BANK'
              ? (bankAccountId ? 'BANK' : null)
              : preview?.endorsementType === 'Non-Financial' ||
                ((preview?.endorsementType === 'Financial' ||
                  preview?.endorsementType === 'Both') &&
                  (premium === '0' || premium === null))
                ? (
                  preview?.premiumStatus === 'REFUND'
                    ? 'WALLET'
                    : (parseFloat(preview?.endorsementItem?.premium) > 0 ? 'WALLET' : null)
                )
                : paymentMode,
          bankAccountId: bankAccountId,
          premium,
          premiumType,
          skipMailToInsurer: true,
          workFlowOption: 'Option 1',
          premiumSource: 'ManualEntry'
        }
      })
        .then((response) => {
          setLoader(false);
          setShowSnackBarAlert({
            status: true,
            type: 'success',
            message: 'Endorsement shared to customer'
          });
          closeModal();
          setPreview({
            status: false,
            type: null,
            insuranceCompanyId: null,
            branchId: null,
            insuranceCompanyBranchId: null,
            insuranceCompanyBranchContact: null,
            otherContact: null,
            ids: null,
            endorsementType: null,
            premiumStatus: null
          });
          getEndorsementData();
          setEndorsementData(null);
          //   handleClose();
        })
        .catch(function (err) {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: err.message
          });
          setLoader(false);
          //   handleClose();
        });
    } else if (type === 'PremiumEnter') {

      request({
        url: 'endorsement/premiumRequestToInsurer',
        method: 'POST',
        data: {
          type: type,
          insuranceCompanyId: policyDetailsData.insuranceCompany.id,
          insuranceCompanyBranchId: policyDetailsData.insuranceCompanyBranch.id,
          // insuranceCompanyBranchContact: insuranceCompanyBranchContact,
          // otherContact: customMail,
          id: endorsementData?.id ? [endorsementData.id] : [],
          premium,
          premiumType,
          skipMailToInsurer: true,
          workFlowOption: 'Option 2',
          premiumSource: 'ManualEntry',
          gst: gstPercentage
          // premiumSource: 'Insurer'
        }
      })
        .then((response) => {
          setLoader(false);
          setShowSnackBarAlert({
            status: true,
            type: 'success',
            message: 'Endorsement shared'
          });
          closeModal();
          setPreview({
            status: false,
            type: null,
            insuranceCompanyId: null,
            branchId: null,
            insuranceCompanyBranchId: null,
            insuranceCompanyBranchContact: null,
            otherContact: null,
            ids: null,
            endorsementType: null,
            premiumStatus: null
          });
          getEndorsementData();
          setEndorsementData(null);
          //   handleClose();
        })
        .catch(function (err) {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: err.message
          });
          setLoader(false);
          //   handleClose();
        });
    } else {
      request({
        url: 'endorsement/premiumRequestToInsurer',
        method: 'POST',
        data: {
          type: type,
          insuranceCompanyId: policyDetailsData.insuranceCompany.id,
          insuranceCompanyBranchId: policyDetailsData.insuranceCompanyBranch.id,
          insuranceCompanyBranchContact: insuranceCompanyBranchContact,
          otherContact: customMail,
          id: endorsementData?.id ? [endorsementData.id] : [],
          premium: null,
          premiumType: null,
          skipMailToInsurer: false,
          workFlowOption: 'Option 1',
          premiumSource: 'Insurer'
        }
      })
        .then((response) => {
          setLoader(false);
          setShowSnackBarAlert({
            status: true,
            type: 'success',
            message: 'Endorsement premium requested'
          });
          setPreview({
            status: false,
            type: null,
            insuranceCompanyId: null,
            branchId: null,
            insuranceCompanyBranchId: null,
            insuranceCompanyBranchContact: null,
            otherContact: null,
            ids: null,
            endorsementType: null,
            premiumStatus: null
          });
          getEndorsementData();
        })
        .catch(function (err) {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: err.message
          });
          setLoader(false);
        });
    }
  };

  const buildStructuredDynamicForm = (allfields, selectedFields) => {
    // if (!Array.isArray(allfields)) return [];
    if (!Array.isArray(allfields) || !Array.isArray(selectedFields)) return [];
    const groupedResult = allfields.map((group, groupIndex) => {
      const matchedForms = selectedFields
        .filter((item) => item.id.startsWith(`${groupIndex}-`))
        .map((item) => item.data);

      return {
        groupName: group.groupName,
        masterForms: matchedForms,
        masterTemplateId: group.masterTemplateId || Math.random()
      };
    });

    return groupedResult.filter((group) => group.masterForms.length > 0);
  };

  const preferNonEmpty = (
    primary: string | undefined | null,
    fallback: string | undefined | null
  ) =>
    typeof primary === 'string' && primary.trim() ? primary.trim() : fallback;

  const getEndorsementPreview = () => {
    setPreviewLoading(true);
    console.log('endorsementFormData', endorsementFormData);
    const structuredDynamicFormData1 = buildStructuredDynamicForm(
      policyDetailsData?.dynamicFormData,
      endorsementFormData?.dynamicFormData
    );
    const structuredDynamicFormData2 = buildStructuredDynamicForm(
      policyDetailsData?.secondDynamicFormData,
      endorsementFormData?.secondDynamicFormData
    );
    const structuredDynamicFormData3 = buildStructuredDynamicForm(
      policyDetailsData?.thirdDynamicFormData,
      endorsementFormData?.thirdDynamicFormData
    );
    const endorsementDataValue = {
      sumInsuredSectionData: endorsementFormData.sumInsuredSectionData,
      dynamicFormData: structuredDynamicFormData1,
      secondDynamicFormData: structuredDynamicFormData2,
      thirdDynamicFormData: structuredDynamicFormData3,
      extended_policy: endorsementFormData?.extended_policy,
      cancellationEffectiveDate: endorsementFormData?.cancellation_Endorsement,
      customerData: null,
      ...(endorsementFormData?.riskDescription?.isSelected && {
        riskDescription: endorsementFormData.riskDescription.newValue,
      }),

      ...(endorsementFormData?.suggestedDeductible?.isSelected && {
        suggestedDeductible: endorsementFormData.suggestedDeductible.newValue,
      }),
      ...(endorsementFormData?.warrantiesExclusions?.isSelected && {
        warrantiesExclusions: endorsementFormData.warrantiesExclusions.newValue,
      }),

      ...(endorsementFormData?.coverageRemark?.isSelected && {
        coverageRemark: endorsementFormData.coverageRemark.newValue,
      }),

      ...(endorsementFormData?.clausesRemark?.isSelected && {
        clausesRemark: endorsementFormData.clausesRemark.newValue,
      }),

      ...(endorsementFormData?.hypothetical_details?.some(
        item => ['create', 'update', 'delete'].includes(item?.action_type)
      ) && {
        hypothetical_details: endorsementFormData.hypothetical_details.filter(
          item => ['create', 'update', 'delete'].includes(item?.action_type)
        )
      }),
    };

    if (
      endorsementFormData.type === 'Non-Financial' ||
      endorsementFormData.type === 'Both'
    ) {
      endorsementDataValue.customerData = {
        insuredName: preferNonEmpty(
          endorsementFormData.customerData?.insuredNameValue,
          policyDetailsData?.customerData?.insuredName
        ),
        address: preferNonEmpty(
          endorsementFormData.customerData?.addressValue,
          policyDetailsData?.customerData?.address
        ),
        branchName: preferNonEmpty(
          endorsementFormData.customerData?.branchNameValue,
          policyDetailsData?.customerData?.branchName
        ),
        city: preferNonEmpty(
          endorsementFormData.customerData?.cityValue,
          policyDetailsData?.customerData?.city
        ),
        pincode: preferNonEmpty(
          endorsementFormData.customerData?.pincodeValue,
          policyDetailsData?.customerData?.pincode
        ),
        gstNo: preferNonEmpty(
          endorsementFormData.customerData?.gstNoValue,
          policyDetailsData?.customerData?.gstNo
        )
      };
    }

    const values = {
      policyId: endorsementFormData.policyId,
      type: endorsementFormData.type,
      subType: endorsementFormData.subType,
      description: endorsementFormData.description?endorsementFormData.description:'N/A',
      endorsementData: { ...endorsementDataValue, type: endorsementFormData.type, subType: endorsementFormData.subType, description: endorsementFormData.description, }
    };



    const URL = 'endorsement/getMailPreviewBeforeCreate';

    request({
      url: URL,
      method: 'POST',
      data: values
    })
      .then((response: any) => {
        setPreviewLoading(false);

        setPreviewHtml(response);
      })
      .catch((err) => {
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: err.message
        });
        setPreviewLoading(false);
      });
  };

  const submitEndorsement = () => {
    setLoading(true);
    const structuredDynamicFormData1 = buildStructuredDynamicForm(
      policyDetailsData?.dynamicFormData,
      endorsementFormData?.dynamicFormData
    );
    const structuredDynamicFormData2 = buildStructuredDynamicForm(
      policyDetailsData?.secondDynamicFormData,
      endorsementFormData?.secondDynamicFormData
    );
    const structuredDynamicFormData3 = buildStructuredDynamicForm(
      policyDetailsData?.thirdDynamicFormData,
      endorsementFormData?.thirdDynamicFormData
    );
    const endorsementDataValue = {
      sumInsuredSectionData: endorsementFormData.sumInsuredSectionData,
      dynamicFormData: structuredDynamicFormData1,
      secondDynamicFormData: structuredDynamicFormData2,
      thirdDynamicFormData: structuredDynamicFormData3,
      extended_policy: endorsementFormData?.extended_policy,
      cancellationEffectiveDate:endorsementFormData?.cancellation_Endorsement,
      customerData: null,
      ...(endorsementFormData?.riskDescription?.isSelected && {
        riskDescription: endorsementFormData.riskDescription.newValue,
      }),

      ...(endorsementFormData?.suggestedDeductible?.isSelected && {
        suggestedDeductible: endorsementFormData.suggestedDeductible.newValue,
      }),
      ...(endorsementFormData?.warrantiesExclusions?.isSelected && {
        warrantiesExclusions: endorsementFormData.warrantiesExclusions.newValue,
      }),

      ...(endorsementFormData?.coverageRemark?.isSelected && {
        coverageRemark: endorsementFormData.coverageRemark.newValue,
      }),

      ...(endorsementFormData?.clausesRemark?.isSelected && {
        clausesRemark: endorsementFormData.clausesRemark.newValue,
      }),

      ...(endorsementFormData?.hypothetical_details?.some(
        item => ['create', 'update', 'delete'].includes(item?.action_type)
      ) && {
        hypothetical_details: endorsementFormData.hypothetical_details.filter(
          item => ['create', 'update', 'delete'].includes(item?.action_type)
        )
      }),
    };

    if (
      endorsementFormData.type === 'Non-Financial' ||
      endorsementFormData.type === 'Both'
    ) {
      endorsementDataValue.customerData = {
        insuredName: preferNonEmpty(
          endorsementFormData.customerData?.insuredNameValue,
          policyDetailsData?.customerData?.insuredName
        ),
        address: preferNonEmpty(
          endorsementFormData.customerData?.addressValue,
          policyDetailsData?.customerData?.address
        ),
        branchName: preferNonEmpty(
          endorsementFormData.customerData?.branchNameValue,
          policyDetailsData?.customerData?.branchName
        ),
        city: preferNonEmpty(
          endorsementFormData.customerData?.cityValue,
          policyDetailsData?.customerData?.city
        ),
        pincode: preferNonEmpty(
          endorsementFormData.customerData?.pincodeValue,
          policyDetailsData?.customerData?.pincode
        ),
        gstNo: preferNonEmpty(
          endorsementFormData.customerData?.gstNoValue,
          policyDetailsData?.customerData?.gstNo
        )
      };
    }

    const values = {
      policyId: endorsementFormData.policyId,
      type: endorsementFormData.type,
      subType: endorsementFormData.subType,
      description: endorsementFormData.description?endorsementFormData.description:'N/A',
      endorsementData: { ...endorsementDataValue, type: endorsementFormData.type, subType: endorsementFormData.subType, description: endorsementFormData.description, }
    };



    const URL = 'endorsement/createEndoresement';

    request({
      url: URL,
      method: 'POST',
      data: values
    })
      .then((response: any) => {
        setLoading(false);
        if (response.status === true) {
          setEndorsementData(response.data);
          setEndorsementCreateStatus(true);
        }
        setShowSnackBarAlert({
          status: true,
          type: response.status ? 'success' : 'error',
          message: response['message']
        });

        // if (response.status) {
        //   closeModal();
        // }
      })
      .catch((err) => {
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: err.message
        });
        setLoading(false);
      });
  };

  const getPolicyDetailData = () => {
    request({
      url: 'insurancePolicy/getPolicyById',
      method: 'post',
      data: {
        policyId: endorsementFormData?.policyId

      }
    }).then(
      (response) => {
        dispatch(updateSelectedPolicyDetails(response['data']))
        setLoading(false);
      },
      (error) => {
        console.log(error);
      }
    );
  }
  return (
    <div>
      {preview.status && (
        <PremiumRequestPreview
          sharePreview={sharePreview}
          preview={preview}
          setPreview={setPreview}
          loader={loader}
          endorsementData={endorsementData}
          setShowSnackBarAlert={setShowSnackBarAlert}
          getEndorsementData={getEndorsementData}
        />
      )}
      <Dialog fullScreen open={true} onClose={closeModal}>
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={closeModal}
              aria-label="close"
              sx={{ marginLeft: 1 }}
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ flex: 1 }} variant="h6" component="div">
              Preview
            </Typography>
          </Toolbar>
        </AppBar>

        <DialogContent>
          <Grid container>
            <Grid item xs={12}>
              <Card sx={{ marginBottam: '10px' }}>
                <CardContent>
                  <div style={{ textAlign: 'right' }}>
                    {endorsementFormData?.type != 'Extension-Endorsement' && <Button
                      variant="outlined"
                      startIcon={<ArrowBackIcon />}
                      onClick={goBack}
                      style={{ marginRight: '15px' }}
                    >
                      Back
                    </Button>}

                    <LoadingButton
                      disabled={endorsementCreateStatus}
                      variant="contained"
                      color="primary"
                      loading={loading}
                      onClick={() => submitEndorsement()}
                    >
                      Save
                    </LoadingButton>
                    {/* {endorsementData === null ? ( */}
                    {endorsementData !== null &&
                      endorsementFormData.type !== 'Non-Financial' ? (
                      <>
                        <LoadingButton
                          sx={{ mt: { xs: 2, md: 0 } }}
                          variant="contained"
                          type="button"
                          style={{ marginLeft: 6 }}
                          color="success"
                          onClick={handleMenuOpen}
                          endIcon={<ArrowDropDownIcon />}
                        >
                          Share
                        </LoadingButton>

                        <Menu
                          anchorEl={anchorEl}
                          open={open}
                          onClose={() => setAnchorEl(null)}
                        >
                          <MenuItem
                            // disabled={endorsementFormData.type === 'Financial'}
                            onClick={() => handleRequest('PremiumRequset')}
                          >
                            Request Premium
                          </MenuItem>
                          <MenuItem
                            onClick={() => handleRequest('PremiumEnter')}
                          >
                            Enter Premium
                          </MenuItem>
                        </Menu>
                      </>
                    ) : endorsementData !== null ? (
                      <Button
                        sx={{ mt: { xs: 2, md: 0 } }}
                        variant="contained"
                        type="button"
                        style={{ marginLeft: 6 }}
                        color="success"
                        onClick={() =>
                          handleRequest('PremiumRequsetToCustomer')
                        }
                      >
                        Share To Customer
                      </Button>
                    ) : null}
                  </div>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} style={{ marginTop: '10px' }}>
              <Card sx={{ marginBottam: '10px' }}>
                <CardContent>

                  {previewLoading ? <div style={{ textAlign: 'center' }}>
                    <img
                      alt="loader"
                      src={loaderImg}
                      className="loader"
                      width={100}
                      height={100}
                    />
                  </div> : (<>
                    {previewHtml && (
                      <Box
                        sx={{
                          width: '100%',
                          height: 'calc(100vh - 120px)',
                          border: '1px solid #ddd',
                          mt: 2
                        }}
                      >
                        <iframe
                          title="Endorsement Preview"
                          srcDoc={`
                          <!DOCTYPE html>
                          <html>
                            <head>
                              <meta charset="utf-8" />
                              <style>
                                html, body {
                                  margin: 0;
                                  padding: 0;
                                  width: 100%;
                                  height: 100%;
                                }
                                * {
                                  box-sizing: border-box;
                                }
                              </style>
                            </head>
                            <body>
                              ${previewHtml}
                            </body>
                          </html>
                        `}
                          style={{
                            width: '100%',
                            height: '100%',
                            border: 'none'
                          }}
                        />
                      </Box>
                    )}
                  </>)}





                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default EndorsementPreview;
